import React, { JSX } from 'react';
import Slider from 'react-slick'

import "./slick.css";
import "./slick-theme.css";

import { CarouselNext, CarouselPrev } from './CustomArrows'

export type CarouselBreakpoint = {
    breakpoint: number,
    settings: CarouselSettings
}

export type CarouselSettings = {
    arrows?: boolean,
    dots?: boolean,
    infinite?: boolean,
    autoplay?: boolean,
    autoplaySpeed?: number,
    speed?: number,
    slidesToShow?: number,
    slidesToScroll?: number,
    centerMode?: boolean,
    centerPadding?: string,
    easing?: string,
    fade?: boolean,
    rtl?: boolean,
    responsive?: CarouselBreakpoint[]
}

export type CarouselProps = CarouselSettings & {
    children?: JSX.Element[] | JSX.Element
}

const SLIDES_TO_SHOW_DEFAULT = 1

const Carousel = ({children, ...settings}: CarouselProps): JSX.Element => {
    const slideCount = React.Children.toArray(children).length
    const loopRequested = settings.infinite ?? true
    const canLoop = (slidesToShow = SLIDES_TO_SHOW_DEFAULT) => loopRequested && slideCount > slidesToShow

    const responsive = settings.responsive?.map(({breakpoint, settings: atBreakpoint}) => ({
        breakpoint,
        settings: {
            ...atBreakpoint,
            infinite: canLoop(atBreakpoint.slidesToShow ?? settings.slidesToShow)
        }
    }))

    return (
        <div className="">
            <Slider
                {...settings}
                infinite={canLoop(settings.slidesToShow)}
                responsive={responsive}
            >
                {children}
            </Slider>
        </div>
    )
}

export default Carousel

export  {
    CarouselNext,
    CarouselPrev
}
